var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2995_26302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8C16.5 3.58206 12.9179 0 8.5 0C4.08206 0 0.5 3.58206 0.5 8C0.5 11.9927 3.42505 15.3025 7.25011 15.9032V10.313H5.21832V8H7.25011V6.2371C7.25011 4.23232 8.44487 3.12417 10.2719 3.12417C11.1472 3.12417 12.0629 3.28055 12.0629 3.28055V5.24933H11.0538C10.0604 5.24933 9.74989 5.86584 9.74989 6.49923V8H11.9684L11.614 10.313H9.74989V15.9032C13.575 15.3036 16.5 11.9938 16.5 8Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.614 10.3139L11.9684 8.00083H9.74983V6.50005C9.74983 5.86779 10.0592 5.25016 11.0537 5.25016H12.0629V3.28138C12.0629 3.28138 11.1471 3.125 10.2718 3.125C8.44481 3.125 7.25004 4.23202 7.25004 6.23792V8.00083H5.21826V10.3139H7.25004V15.9041C7.6573 15.9682 8.07468 16.0008 8.49994 16.0008C8.92519 16.0008 9.34258 15.9671 9.74983 15.9041V10.3139H11.614Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2995_26302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.18c45368c6846f11bce07bba7e8d6376.svg";
export { ForwardRef as ReactComponent };